import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageTitle() {
  const loc = useLocation();
  useEffect(() => {
    const p = loc.pathname;
    let title = "Pelico Data";
    if (p.startsWith("/admin")) title = "Pelico Data · Admin";
    else if (p === "/login") title = "Login · Pelico Data";
    else if (p.startsWith("/dashboard")) title = "Pelico Data";
    else if (p === "/about") title = "About · Pelico Data";
    else if (p === "/faq") title = "FAQ · Pelico Data";
    else if (p === "/contact") title = "Contact · Pelico Data";
    document.title = title;
  }, [loc.pathname]);
  return null;
}
